import { createReducer } from 'Helpers/redux'
import {
  GET_SPOTIFY_ACCESS_TOKEN,
  GET_FREE_SPOTIFY_ACCESS_TOKEN,
} from '../actions/spotifyTokenActions'
import { GET_SPOTIFY_AVATAR } from '../actions/auth'

const initialState = {
  accessToken: null,
  country: null,
}

const handlers = {
  [GET_SPOTIFY_ACCESS_TOKEN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    accessToken: payload.access_token,
  }),
  [GET_FREE_SPOTIFY_ACCESS_TOKEN.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    accessToken: payload.access_token,
    country: payload.country,
  }),
  [GET_SPOTIFY_AVATAR.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    accessToken: payload.token,
  }),
}

export default createReducer(initialState, handlers)
